import { useTranslation } from 'react-i18next';

interface IUseCampaignTextReturn {
  disableDeprecatedMetaDuplicate: string;
  disableDeprecatedMetaPublish: string;
  disableEmailRepublish: string;
  disableLookalikeDuplicate: string;
  disableMove: string;
  disableStopOrRepublishPastEndDate: string;
  disableSaveStartedSingleSend: string;
  disableEdit: string;
  disableDuplicateSmartSend: string;
  disableEditStoppedOrComplete: string;
}

function useCampaignText(): IUseCampaignTextReturn {
  const { t } = useTranslation();

  return {
    disableDeprecatedMetaDuplicate: t(
      'This Meta campaign type has been deprecated and can no longer be duplicated. Create a new Pixl Plus campaign instead.',
    ),
    disableDeprecatedMetaPublish: t(
      'This Meta campaign type has been deprecated and can no longer be published. Create a new Pixl Plus campaign instead.',
    ),
    disableEmailRepublish: t(
      'Auto Send and Smart campaigns cannot be re-enabled and should be duplicated instead',
    ),
    disableLookalikeDuplicate: t(
      'This lookalike campaign type is outdated and can no longer be duplicated',
    ),
    disableMove: t("Invites, landing page, and monetization campaigns can't be moved"),
    disableStopOrRepublishPastEndDate: t(
      'This campaign can no longer be published or stopped because it is past the end date',
    ),
    disableSaveStartedSingleSend: t(
      'Single Send campaigns cannot be stopped or edited after sending has started',
    ),
    disableEdit: t('This campaign can no longer be edited'),
    disableDuplicateSmartSend: t(
      'Smart Send campaigns cannot be duplicated. Instead, create a new Smart Send campaign',
    ),
    disableEditStoppedOrComplete: t(
      'A stopped or completed campaign cannot be edited unless it is re-published.',
    ),
  };
}

export default useCampaignText;
